<script setup>
import { DropdownMenuTrigger as DropdownMenuTriggerRoot } from "reka-ui";
import { cn } from "@/shared/lib/utils";

defineOptions({ inheritAttrs: false });

const props = defineProps({
  class: { type: [String, Object, Array], default: "" },
});
</script>

<template>
  <DropdownMenuTriggerRoot :class="cn('', props.class)" v-bind="$attrs">
    <slot />
  </DropdownMenuTriggerRoot>
</template>
